import TB from '@tiger/bridge';
import { Button } from 'antd';
import { FC } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import BottomBox from 'components/BottomBox';
import TaxLimit from 'modules/Deposit/components/TaxLimit';
import { TaxLimitInfo } from 'modules/Deposit/type';
import successIcon from 'static/images/icons/contributionComplete.png';
import APP from 'stores/APP';
import { lessVersion } from 'utils/util';
import style from './style.scss';

const Complete: FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state as {
        tax: TaxLimitInfo;
    } | null;

    const handleConfirm = () => {
        if (APP.isTiger) {
            if (!lessVersion('2.6.0')) {
                TB.goNativePage('/home/trade');

                return;
            }

            if (window.TigerBridge.quit) {
                TB.quit();
            } else {
                navigate('/profile');
            }
        } else {
            navigate('/profile');
        }
    };

    if (!locationState?.tax?.year) {
        return <Navigate to="/profile/deposit" replace />;
    }

    return (
        <div className={style.root}>
            <div className={style.result}>
                <img src={successIcon} alt="success" className={style.icon} />
                <div className={style.content}>{__('Contribution initiated successfully')}</div>
                <TaxLimit successYear={locationState.tax.year} cost={locationState.tax.cost} />
            </div>
            <BottomBox className="btn-box">
                <Button block type="primary" className="btn-important" onClick={handleConfirm}>
                    {__('Done')}
                </Button>
            </BottomBox>
        </div>
    );
};

export default Complete;
